import React, { Component } from 'react';
import {
    Container,
    Card,
    CardHeader, CardBody,
    Input,
    Button,
    Row,
    Col,
    Collapse
} from 'reactstrap';
import * as XLSX from "xlsx-js-style";
import './ImportData.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import CompanyContext from '../../auth/CompanyContext';
import { Prompt } from 'react-router-dom';

class ImportData extends Component {
    static contextType = CompanyContext;

    constructor(props) {

        super(props);

        this.batchLimit = 100;

        this.state = {
            data: [],
            tableName: '',
            columns: [],
            filename: '',
            totalRows: 0,
            rowsParsed: 0,
            isLoaded: false,
            isParsing: false,
            isDone: false,
            inputFile: '',
            tablesToImport: [],
            tableToImport: '',
            open: (this.props.open !== undefined) ? this.props.open : false,
        };

    }

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return;
        };
    }

    handleUpload = (e) => {
        e.preventDefault();
        console.log(e.target, e.target.value, e.target.name);
        var files = e.target.files, f = files[0];
        console.log(f.name);
        const fileMatch = (f.name.length === 13 || f.name.length === 15) ? f.name.match(/[0-9]{6,8}/) : f.name.match(/[0-9]{4}-[0-9]{1,2}-[0-9]{1,4}/);
        if (fileMatch.length > 0) {
            const fileDate = fileMatch[0].split('-');
            const tableName = f.name.length === 13 ? fileMatch[0] : (f.name.length === 15 ? fileMatch[0].substring(0, 4) + fileMatch[0].substring(6, 8) : String(fileDate[1]).padStart(2, '0') + String(fileDate[2]).padStart(2, '0') + String(fileDate[0]).substring(2, 4));
            const dateString = `20${tableName.substring(4, 6)}-${tableName.substring(0, 2)}-${tableName.substring(2, 4)}`;
            console.log('Importing data for date: ', dateString);
            let deletedFields = [];
            this.setState({
                isParsing: true,
                inputFile: e.target.value
            }, () => {
                var reader = new FileReader();
                reader.onload = (e) => {
                    var data = e.target.result;
                    let readedData = XLSX.read(data, { type: 'binary', cellDates: true });
                    const wsname = readedData.SheetNames[0];
                    const ws = readedData.Sheets[wsname];
                    /* Convert array to json*/

                    this.setState({

                    }, () => {
                        // console.log(columns.length)
                        const json_request = JSON.stringify({ dateString });

                        fetch('/api/import/', {
                            method: 'POST',
                            body: json_request,
                            headers: {
                                'Content-Type': 'application/json',
                                'Authorization': 'Bearer ' + this.props.clientToken,
                                'X-Database': this.context.company
                            }
                        })
                            .then(results => results.json())
                            .then(results => {
                                if (!results.success) return;
                                const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1 });
                                let columns = dataParse[0].slice();
                                dataParse[0] = dataParse[0].map(el => (el in changeFields) ? changeFields[el] : el);

                                let targetColumnList = results.data.map(i => {
                                    return `${i.column.toString()}`
                                });
                                columns.forEach(column => {
                                    if (targetColumnList.findIndex(targetColumn => String(targetColumn).trim().toLowerCase() === String(column).trim().toLowerCase()) === -1) deletedFields.push(column);
                                })
                                deletedFields.forEach(field => {
                                    const index = dataParse[0].findIndex(col => col === field);
                                    // console.log(index);
                                    if (index > -1) {
                                        dataParse.map(row => row.splice(index, 1));
                                    }
                                });
                                const tableColumns = dataParse.splice(0, 1)[0].map(el => "[" + el + "]");
                                tableColumns.push("[Import Date]");
                                dataParse.forEach((row, i) => {
                                    row.push(dateString);
                                });
                                this.setState({
                                    data: dataParse,
                                    totalRows: dataParse.length,
                                    isParsing: true,
                                    isLoaded: true,
                                    tableName: tableName /*+ '_TEST'*/,
                                    columns: tableColumns
                                }, () => {
                                    this.insertData(0);
                                })
                            });
                    });
                };
                reader.readAsBinaryString(f)
            })
        }

    }

    insertData(startPos, uploadBatch = []) {
        if (uploadBatch.length === 0) uploadBatch = this.state.data.splice(0, this.batchLimit);

        fetch('/api/import/', {
            method: 'PUT',
            body: JSON.stringify({
                data: uploadBatch,
                tableName: this.state.tableName,
                columns: this.state.columns
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken,
                'X-Database': this.context.company
            }
        })
            .then(results => results.json())
            .then(results => {
                // console.log(results);
                if (results.debug_message.error != null) return;
                if (this.state.data.length > 0) {
                    this.setState({
                        rowsParsed: parseInt(startPos) + this.batchLimit
                    })
                    this.insertData(parseInt(startPos) + this.batchLimit);
                } else {
                    this.setState({
                        rowsParsed: this.state.totalRows,
                        isParsing: false,
                        isDone: true
                    }, () => {
                        fetch('/api/import/refresh/', {
                            method: 'GET',
                            headers: {
                                'Authorization': 'Bearer ' + this.props.clientToken,
                                'X-Database': this.context.company
                            }
                        })
                    })
                }
            })
            .catch(reason => {
                console.log(reason);
                this.insertData(parseInt(startPos), uploadBatch);
            })

    }

    resetUpload = () => {
        this.setState({
            data: [],
            columns: [],
            filename: '',
            totalRows: 0,
            rowsParsed: 0,
            isLoaded: false,
            isDone: false,
            isParsing: false,
            inputFile: ''
        })
    }

    setDownloadFile = (e) => {
        e.persist();
        this.setState({
            tableToImport: e.target.value
        })
    }

    downloadFile = () => {
        /*const link = this.state.tablesToImport.filter(table => table.table === this.state.tableToImport)[0].link;
        fetch('https://www.sec.gov/files/investment/data/information-about-registered-investment-advisers-and-exempt-reporting-advisers/ia030119-exempt.zip', {
            mode: 'cors'
        })
            .then(results => {
                console.log(results);
            });*/
    }

    showHide(element) {
        this.setState({
            open: !this.state.open
        })
    }

    render() {
        return (
            <Container fluid>
                <Prompt
                    when={this.state.isParsing}
                    message="Data is currently being imported, are you sure you want to leave?"
                />
                <Card>
                    <CardHeader onClick={() => this.showHide()}>
                        <Row className="align-items-center">
                            <Col className="col-md-7 text-left">
                                <h3>Import SEC Data</h3>
                            </Col>
                            <Col className="col-md-4 text-right">
                                {this.state.isDone ? <Button color="primary" onClick={this.resetUpload}>Import Another</Button> : <></>}
                            </Col>
                            <Col xs="1" className="text-right">
                                {(this.state.open) ? <FontAwesomeIcon icon={faChevronUp} /> : <FontAwesomeIcon icon={faChevronDown} />}
                            </Col>
                        </Row>
                    </CardHeader>
                    <Collapse isOpen={this.state.open}>
                        <CardBody>
                            {(!this.state.isParsing && !this.state.isDone) ?
                                <>
                                    <Row className="align-items-center">
                                        <Col className="col-md-6 text-left">
                                            <Input type="file" name="file" accept='.xlsx' onChange={e => this.handleUpload(e)} value="" />
                                        </Col>
                                        <Col className="col-md-6 text-right">
                                            Imports an SEC .xlsx file (caution: will overwrite existing data)
                                        </Col>
                                        {/*<Col className="col-md-4">
                                    <Input type="select" name="importURL" onChange={e => this.setDownloadFile(e)} value={this.state.tableToImport} >
                                        <option value="">Or select ZIP file</option>
                                        {this.state.tablesToImport.map(table => (
                                            <option value={table.table}>{table.date}</option>
                                        ))}
                                    </Input>
                                </Col>
                                <Col className="col-md-2">
                                    <Button onClick={this.downloadFile} color="primary" disabled={this.state.tableToImport === ""}>GO</Button>
                                        </Col>*/}
                                    </Row>
                                    {(this.state.tablesToImport.length > 0) ? <Row>
                                        <Col className="col-md-12 text-left"><hr />Downloads:
                                            {this.state.tablesToImport.map((table, i) => (
                                                <a key={i} className="tableLink" href={table.link}>{table.date}</a>
                                            ))}
                                        </Col>
                                    </Row> : <></>} </> : <></>
                            }
                            {(this.state.isParsing || this.state.isDone) ?
                                <Row className="align-items-center">
                                    <Col className="col-md-8">
                                        <div className={"progress progress-lg " + ((!this.state.isDone) ? "progress-striped active" : "")}>
                                            <div role={"progressbar " + ((!this.state.isDone) ? " progress-striped" : "")}
                                                style={{ width: this.state.totalRows > 0 ? 100 * (this.state.rowsParsed / this.state.totalRows) + "%" : "0" }}
                                                className={"progress-bar " + ((this.state.isDone) ? "progress-bar-success" : "")}><span>{this.state.totalRows > 0 ?
                                                    (Math.round(100 * (this.state.rowsParsed / this.state.totalRows))) + "%"
                                                    : "0%"}</span></div>
                                        </div>
                                        {/*<div className="progressBar">
                                        <div className="progressBarMeter" style={{ width: this.state.totalRows > 0 ? 100 * (this.state.rowsParsed / this.state.totalRows) + "%" : "0" }}></div>
                                     </div>*/}
                                    </Col>
                                    <Col className="col-md-4 text-right">
                                        {this.state.rowsParsed} Records Imported
                                    </Col>
                                </Row> : <></>
                            }
                        </CardBody>
                    </Collapse>
                </Card>
            </Container>
        );
    }
}

export default ImportData;

const changeFields = {
    // '5E(7)-Other':              '5E(7-Other)',
    // '5G(12)-Other':             '5G(12-Other)',
    '5D(a)(1)': 'Individual Accounts',
    '5D(a)(3)': 'Individual AUM',
    '5D(b)(1)': 'HNW Accounts',
    '5D(b)(3)': 'HNW AUM',
    '5D(c)(1)': 'Banking or Thrift Institutions Accounts',
    '5D(c)(3)': 'Banking or Thrift Institutions AUM',
    '5D(d)(1)': 'Investment Companies Accounts',
    '5D(d)(3)': 'Investment Companies AUM',
    '5D(e)(1)': 'Business Development Companies Accounts',
    '5D(e)(3)': 'Business Development Companies AUM',
    '5D(f)(1)': 'Pooled Investment Vehicles Accounts',
    '5D(f)(3)': 'Pooled Investment Vehicles AUM',
    '5D(g)(1)': 'Pension Accounts',
    '5D(g)(3)': 'Pension AUM',
    '5D(h)(1)': 'Charitable Organizations Accounts',
    '5D(h)(3)': 'Charitable Organizations AUM',
    '5D(i)(1)': 'Government Entities Accounts',
    '5D(i)(3)': 'Government Entities AUM',
    '5D(j)(1)': 'Other Investment Advisors Accounts',
    '5D(j)(3)': 'Other Investment Advisors AUM',
    '5D(k)(1)': 'Insurance Companies Accounts',
    '5D(k)(3)': 'Insurance Companies AUM',
    '5D(l)(1)': 'Sovereign Wealth Funds and Foreign Official Institutions Accounts',
    '5D(l)(3)': 'Sovereign Wealth Funds and Foreign Official Institutions AUM',
    '5D(m)(1)': 'Corporations Not Listed Accounts',
    '5D(m)(3)': 'Corporations Not Listed AUM',
    '5D(n)(1)': 'Family Foundations Accounts',
    '5D(n)(3)': 'Family Foundations AUM',
    '5F(2)(a)': 'Discretionary AUM',
    '5F(2)(b)': 'Non-Discretionary AUM',
    '5F(2)(c)': 'Total AUM',
    '5F(2)(d)': 'Discretionary Accounts',
    '5F(2)(e)': 'Non-Discretionary Accounts',
    '5F(2)(f)': 'Total Accounts',
    '5F(2)€ # acts non-disc': 'Non-Discretionary Accounts',
    '5F(2)© AUM Total': 'Total AUM',
}
